<ng-container *ngIf="content">
  <section>
    <h1 class="font-heading-3 font-headline-small">
      <div class="font-body-1 nordic-blue-900-text text-icon-primary light-type font-body-medium">
        {{ 'flightsTo' | finLocalization }}
      </div>
      <div class="font-heading-1 nordic-blue-900-text text-icon-primary font-headline-medium">
        {{ content | finMap: 'title' }}
      </div>
    </h1>
    <div class="ms-medium-y" *ngIf="content.detailText" [innerHTML]="content | finMap: 'detailText'"></div>
  </section>
</ng-container>
